import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../../utils/seo';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://mykinesiologue.ma';

  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `${siteUrl}/#organization`,
    "name": "MyKinesiologue Marrakech",
    "description": "Kinésiologue à Marrakech. Accompagnement personnalisé en kinésiologie émotionnelle, gestion du stress et équilibre énergétique. Approche douce et bienveillante pour retrouver votre harmonie intérieure.",
    "url": siteUrl,
    "telephone": "+212776664292",
    "email": "tatiana@mykunesiologue.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Marrakech",
      "addressCountry": "MA"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "31.6295",
      "longitude": "-7.9811"
    },
    "priceRange": "$$",
    "image": "https://static.readdy.ai/image/48f019ad192905b3f4ede24b194a300b/9e4b5e4e7afefada3563c5975e98200f.png",
    "sameAs": [],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      }
    ],
    "areaServed": {
      "@type": "City",
      "name": "Marrakech"
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#F7F3EE]">
      <SEO
        title="MyKinesiologue Marrakech - Kinésiologie"
        description="Kinésiologue à Marrakech. Accompagnement personnalisé en kinésiologie émotionnelle, gestion du stress et équilibre énergétique. Approche douce et bienveillante pour retrouver votre harmonie intérieure."
        keywords="kinésiologue Marrakech, kinésiologie émotionnelle, gestion du stress, équilibre énergétique, bien-être Marrakech"
        canonical={siteUrl}
        schema={schema}
      />

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-[1120px] mx-auto px-4 md:px-8 py-4 md:py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src="https://static.readdy.ai/image/48f019ad192905b3f4ede24b194a300b/9e4b5e4e7afefada3563c5975e98200f.png" alt="MyKinesiologue" className="h-8 md:h-12" />
          </Link>
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-[#1F1F1F] cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`} style={{ fontSize: '24px' }}></i>
          </button>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-[#1F4D45] font-semibold transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Accueil</Link>
            <Link to="/approche" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Approche</Link>
            <Link to="/a-qui-sadresse" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>À qui s'adresse</Link>
            <Link to="/presence" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Présence</Link>
            <Link to="/contenus-multimedia" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Contenus multimédia</Link>
            <Link to="/prendre-rendez-vous" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Prendre rendez-vous</Link>
            <Link to="/faq" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>FAQ</Link>
            <Link to="/prendre-rendez-vous#contact" className="bg-[#1F4D45] text-[#F7F3EE] px-6 h-11 rounded-2xl flex items-center justify-center whitespace-nowrap hover:bg-[#1F4D45]/90 hover:translate-y-[-1px] transition-all duration-300 cursor-pointer ml-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px', fontWeight: '500' }}>Me contacter</Link>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-[#C9C1B8]">
            <div className="px-4 py-6 flex flex-col gap-4">
              <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F4D45] font-medium transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Accueil</Link>
              <Link to="/approche" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Approche</Link>
              <Link to="/a-qui-sadresse" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>À qui s'adresse</Link>
              <Link to="/presence" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Présence</Link>
              <Link to="/contenus-multimedia" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Contenus multimédia</Link>
              <Link to="/prendre-rendez-vous" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Prendre rendez-vous</Link>
              <Link to="/faq" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>FAQ</Link>
              <Link to="/prendre-rendez-vous#contact" onClick={() => setIsMobileMenuOpen(false)} className="bg-[#1F4D45] text-[#F7F3EE] px-6 h-12 rounded-2xl flex items-center justify-center whitespace-nowrap cursor-pointer mt-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Me contacter</Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="pt-32 md:pt-48 pb-16 md:pb-32 bg-[#F7F3EE]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16">
            <div className="w-full md:w-[45%]">
              <div className="inline-block border border-[#C9C1B8] rounded-full px-4 py-2 mb-8 md:mb-12">
                <span className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '13px' }}>Kinésiologie à Marrakech</span>
              </div>
              <h1 className="text-[#1F1F1F] mb-6 md:mb-8" style={{ fontFamily: 'Fraunces, serif', fontSize: '50px', lineHeight: '1.1', fontWeight: '600' }}>
                Quand le corps retrouve sa capacité d'ajustement
              </h1>
              <p className="text-[#5E5A55] mb-6 md:mb-8" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Une approche précise et non invasive pour accompagner le stress, les tensions et les périodes de transition, en s'appuyant sur l'intelligence du corps.
              </p>
              <p className="text-[#5E5A55] mb-8 md:mb-16" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Chaque séance est unique. Le travail se fait avec ce que le corps rend disponible, au moment juste.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="https://wa.me/212776664292" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-[#1F4D45] text-[#F7F3EE] px-6 md:px-8 h-12 rounded-2xl whitespace-nowrap hover:translate-y-[-2px] transition-all duration-400 cursor-pointer" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>
                  <i className="ri-whatsapp-line"></i>
                  WhatsApp
                </a>
                <a href="mailto:tatiana@mykunesiologue.com" className="inline-flex items-center justify-center gap-3 border border-[#1F4D45] text-[#1F4D45] bg-transparent px-6 md:px-8 h-12 rounded-2xl whitespace-nowrap hover:bg-[#1F4D45] hover:text-[#F7F3EE] transition-all duration-400 cursor-pointer" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>
                  <i className="ri-mail-line"></i>
                  Message privé
                </a>
              </div>
            </div>
            <div className="w-full md:w-[55%] md:ml-16">
              <img 
                src="https://public.readdy.ai/ai/img_res/752fcf085f1c3bc11dfc0d2bca02a073.jpg" 
                alt="Séance de kinésiologie" 
                className="w-full h-[400px] md:h-[600px] object-cover object-top rounded-[24px] md:rounded-[32px]"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Pourquoi la kinésiologie Section */}
      <section className="py-20 md:py-40 bg-[#E9E0D4]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16">
            <div className="w-full md:w-1/2">
              <img 
                src="https://readdy.ai/api/search-image?query=abstract%20close-up%20of%20natural%20woven%20textile%20with%20organic%20irregular%20pattern%2C%20handcrafted%20linen%20or%20cotton%20fabric%20in%20warm%20beige%20tones%2C%20tactile%20surface%20with%20visible%20texture%20and%20depth%2C%20premium%20material%20photography%2C%20soft%20diffused%20lighting%2C%20minimalist%20composition%2C%20no%20person%2C%20artisanal%20quality%2C%20calm%20and%20contemplative%20mood%2C%20earth%20tones&width=600&height=700&seq=woven-textile-organic-v3&orientation=portrait" 
                alt="Approche kinésiologique" 
                className="w-full h-[500px] md:h-[650px] object-cover object-top rounded-[24px] md:rounded-[32px]"
              />
            </div>
            <div className="w-full md:w-1/2 md:pl-16">
              <h2 className="text-[#1F1F1F] mb-6 md:mb-8" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
                Pourquoi la kinésiologie ?
              </h2>
              <p className="text-[#5E5A55] mb-6" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Le corps s'adapte en permanence. Il compense, tient, absorbe.
              </p>
              <p className="text-[#5E5A55] mb-6" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Avec le temps, cette adaptation peut se manifester par :
              </p>
              <ul className="space-y-3 mb-6">
                {[
                  'du stress persistant',
                  'des tensions corporelles',
                  'une fatigue qui ne se résorbe pas',
                  'une sensation de blocage, malgré la volonté d’avancer'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <span className="text-[#1F4D45] mt-1 flex-shrink-0">—</span>
                    <span className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>{item}</span>
                  </li>
                ))}
              </ul>
              <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                La kinésiologie permet d'identifier là où ces mécanismes restent actifs et de favoriser des ajustements plus justes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Comment se déroule une séance Section */}
      <section className="py-20 md:py-40 bg-[#F7F3EE]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16">
            <div className="w-full md:w-1/2 md:order-2">
              <img 
                src="https://readdy.ai/api/search-image?query=minimalist%20architectural%20detail%20showing%20intersection%20of%20natural%20wood%20beam%20and%20smooth%20beige%20wall%2C%20geometric%20composition%20with%20clean%20lines%2C%20warm%20natural%20light%20creating%20subtle%20gradient%2C%20premium%20interior%20design%20photography%2C%20no%20person%2C%20high-end%20material%20quality%2C%20calm%20professional%20space%2C%20sand%20and%20ivory%20tones%2C%20silent%20atmosphere&width=600&height=700&seq=wood-wall-intersection-v3&orientation=portrait" 
                alt="Séance de kinésiologie" 
                className="w-full h-[500px] md:h-[650px] object-cover object-top rounded-[24px] md:rounded-[32px]"
              />
            </div>
            <div className="w-full md:w-1/2 md:order-1">
              <h2 className="text-[#1F1F1F] mb-6 md:mb-8" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
                Comment se déroule une séance ?
              </h2>
              <p className="text-[#5E5A55] mb-6" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                La séance repose sur le test musculaire, outil central de la kinésiologie.
              </p>
              <p className="text-[#5E5A55] mb-6" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Il permet d'orienter le travail en fonction de ce qui est pertinent ici et maintenant.
              </p>
              <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Présence, écoute et techniques utilisées agissent conjointement pour soutenir les capacités naturelles de régulation du corps.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* À qui s'adresse Section */}
      <section className="py-20 md:py-40 bg-[#E9E0D4]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="max-w-[900px] mx-auto">
            <h2 className="text-[#1F1F1F] mb-8 md:mb-12 text-center" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
              À qui s'adresse cette approche ?
            </h2>
            <p className="text-[#5E5A55] mb-6 text-center" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
              La kinésiologie s'adresse aux personnes qui souhaitent :
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-12 md:mb-16">
              {[
                'mieux comprendre ce que leur corps exprime',
                'traverser une période de transition',
                'accompagner des tensions ou des douleurs persistantes',
                'retrouver plus de disponibilité intérieure, de clarté mentale et une présence plus juste à soi-même'
              ].map((item, index) => (
                <div key={index} className="bg-[#F7F3EE] border border-[#C9C1B8] rounded-2xl p-6 md:p-8 flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-checkbox-circle-line text-[#1F4D45]" style={{ fontSize: '24px' }}></i>
                  </div>
                  <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                    {item}
                  </p>
                </div>
              ))}
            </div>

            <div className="bg-[#F7F3EE] border border-[#C9C1B8] rounded-2xl p-8 md:p-12 text-center">
              <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Selon les situations, une séance peut déjà apporter une évolution perceptible, une amélioration ou une compréhension plus claire de ce qui se joue.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="contact" className="py-20 md:py-40 bg-[#F7F3EE]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8 text-center">
          <h2 className="text-[#1F1F1F] mb-6" style={{ fontFamily: 'Fraunces, serif', fontSize: '38px', lineHeight: '1.2', fontWeight: '600' }}>
            Prêt à commencer ?
          </h2>
          <p className="text-[#5E5A55] mb-8 md:mb-12 max-w-2xl mx-auto" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
            Contactez-moi pour échanger sur votre situation
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a href="https://wa.me/212776664292" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#1F4D45] text-[#F7F3EE] px-6 md:px-8 h-12 rounded-2xl whitespace-nowrap hover:translate-y-[-2px] transition-all duration-400 cursor-pointer" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>
              <i className="ri-whatsapp-line"></i>
              WhatsApp
            </a>
            <a href="mailto:tatiana@mykunesiologue.com" className="inline-flex items-center gap-3 border border-[#1F4D45] text-[#1F4D45] bg-transparent px-6 md:px-8 h-12 rounded-2xl whitespace-nowrap hover:bg-[#1F4D45] hover:text-[#F7F3EE] transition-all duration-400 cursor-pointer" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>
              <i className="ri-mail-line"></i>
              Message privé
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1F4D45] py-12 md:py-16">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12">
            <div>
              <Link to="/" className="inline-block mb-4">
                <img src="https://static.readdy.ai/image/48f019ad192905b3f4ede24b194a300b/9e4b5e4e7afefada3563c5975e98200f.png" alt="MyKinesiologue" className="h-10" />
              </Link>
              <p className="text-[#E9E0D4]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>
                Kinésiologie à Marrakech
              </p>
            </div>
            <div>
              <h3 className="text-[#E9E0D4] uppercase tracking-wider mb-4" style={{ fontFamily: 'Inter, sans-serif', fontSize: '12px', letterSpacing: '1.5px' }}>
                Navigation
              </h3>
              <div className="grid grid-cols-2 gap-x-6 gap-y-2">
                <Link to="/" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Accueil</Link>
                <Link to="/contenus-multimedia" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Contenus multimédia</Link>
                <Link to="/approche" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Approche</Link>
                <Link to="/prendre-rendez-vous" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Prendre rendez-vous</Link>
                <Link to="/a-qui-sadresse" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>À qui s'adresse</Link>
                <Link to="/faq" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>FAQ</Link>
                <Link to="/presence" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Présence</Link>
              </div>
            </div>
            <div>
              <h3 className="text-[#E9E0D4] uppercase tracking-wider mb-4" style={{ fontFamily: 'Inter, sans-serif', fontSize: '12px', letterSpacing: '1.5px' }}>
                Contact
              </h3>
              <div className="flex flex-col gap-2">
                <a href="mailto:tatiana@mykunesiologue.com" className="text-[#F7F3EE] hover:underline break-all" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>tatiana@mykunesiologue.com</a>
                <a href="tel:+212776664292" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>+212 0776664292</a>
                <p className="text-[#E9E0D4] mt-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>
                  Marrakech, Maroc
                </p>
              </div>
            </div>
          </div>
          <div className="border-t border-[#F7F3EE]/20 pt-6 text-center">
            <p className="text-[#E9E0D4]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '12px' }}>
              © 2025 MyKinesiologue. Tous droits réservés.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
